import { etimUnits } from "./generated/etim-units.js";
export { etimUnits };
export function getUnits(t, language) {
    const units = etimUnits
        .map(etimUnit => {
        const translatedUnit = translateEtimUnit(etimUnit, t);
        return translatedUnit;
    })
        .sort((u1, u2) => u1.value.localeCompare(u2.value, language));
    return units;
}
export function getUnitByKey(key, t) {
    const unit = etimUnits.find(etimUnit => etimUnit.value === key);
    if (!unit) {
        return null;
    }
    const translatedUnit = translateEtimUnit(unit, t);
    return translatedUnit;
}
function translateEtimUnit(unit, t) {
    const valueTranslation = t(unit.key, {
        ns: "EtimUnitsValue",
        defaultValue: unit.value,
    });
    const descriptionTranslation = t(unit.key, {
        ns: "EtimUnitsDescription",
        defaultValue: unit.description,
    });
    return {
        key: unit.key,
        value: valueTranslation,
        description: descriptionTranslation,
    };
}
// backend version
export function getUnitByKeyDefined(key, t) {
    const unit = etimUnits.find(etimUnit => etimUnit.value === key);
    if (!unit) {
        return null;
    }
    const translatedUnit = translateEtimUnitDefined(unit, t);
    return translatedUnit;
}
function translateEtimUnitDefined(unit, t) {
    const valueTranslation = t(unit.key, {
        ns: "EtimUnitsValue",
        defaultValue: unit.value,
    });
    const descriptionTranslation = t(unit.key, {
        ns: "EtimUnitsDescription",
        defaultValue: unit.description,
    });
    return {
        key: unit.key,
        value: valueTranslation,
        description: descriptionTranslation,
    };
}
//# sourceMappingURL=units.js.map